import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Desarrolloinclusivo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Desarrollo Inclusivo"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Fomentar y apoyar proyectos y actividades creados por y para la comunidad LGBTTTIQ+ que promuevan la inclusión, los derechos, la salud y el desarrollo económico inclusivo, de acuerdo con eI Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de Atención Prioritaria Indígena del Estado de Hidalgo.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}></h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Fomentar y apoyar proyectos y actividades creados por y para la comunidad LGBTTTI que promuevan la inclusión, los derechos, la salud y el desarrollo económico inclusivo, de acuerdo con el Plan Estatal de Desarrollo 2022-2028, dando prioridad a las localidades de alta y muy alta marginación, en pobreza o en los 22 municipios de Atención Prioritaria Indígena del Estado de Hidalgo.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Personas de la comunidad LGBTTTIQ+ de los 18 a los 64 años, que cuenten con residencia en Hidalgo, sin acceso a los servicios de salud o atención médica, de las 12 regiones del Estado de Hidalgo de acuerdo con el Plan Estatal de Desarrollo 2022-2028, dando prioridad a localidades de alta y muy alta marginación, en situación de pobreza o en los 22 municipios de atención prioritaria indígena.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa “Desarrollo Inclusivo” tendrá cobertura en los 84 municipios del Estado de Hidalgo, así como en las 12 regiones, de acuerdo con el Plan Estatal de Desarrollo 2022-2028.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p> 
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Desarrollo Social y Humano</b></li>
                <dd>Calle Francisco Maldonado Lecona #101, Segundo Piso, Colonia Ampliación Santa Julia CP.  42080. Pachuca de Soto; Hidalgo.</dd>
                
                </ul>
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Persona Responsable del Programa</h5>
                <p>
                Lic. Miriam Margarita Laguna León, Subdirectora de Área
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                Pendiente
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2026/ROP_Desarrollo_Inclusivo_2026.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2026</a>
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Convocatoria y Registro</h5>
                <ul>
                <li>
                <a
                href='/Programas/DI2026'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Marzo 2026</a>
                </li>
                </ul>
               
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Consulta de folios beneficiados</h5>
                <ul>
                <li>
                <a
                href='https://amigosdelatransformacion.com.mx/pro.php'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Febrero 2024</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/FOLIOS/BEN_DI_OCT2024.jpeg'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Octubre 2024</a>
                </li>
                </ul>
                <p>
                </p>
                </p>
                
              </div>
            </div>
            
          </div>
        </div>
  
      </div>    
    </div>
  );
};

export default Desarrolloinclusivo;